import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import User from '../../records/User';
import CustomerActions from '../../actions/CustomerActions';

import {GlobalModals, SignupTypes, SmartcardSelfRegistrationStatuses} from '../../constants/AppConstants';
import BaseModal from '../general/BaseModal';
import RegisterSmartcard from '../login/RegisterSmartcard';
import SmartcardRegistration from '../../records/customer/SmartcardRegistration';
import PureRenderComponent from '../PureRenderComponent';
import ModalActions from "../../actions/ModalActions";
import RegisterSuccessModal from "../login/RegisterSuccessModal";
import { SelfSmartcardRegistrationError } from "../../errors/Smartcard";
import { serviceUnavailable } from "../../helpers/ServiceUnavailable";


class SmartcardModal extends PureRenderComponent {

    static propTypes = {
        user: PropTypes.instanceOf(User).isRequired,
        onRegister: PropTypes.func,
        onCancel: PropTypes.func,
        hideSmartcardCheckbox: PropTypes.bool,
        disableSuccessDropdown: PropTypes.bool,
        onSmartcardSuccess: PropTypes.func,
        withISRN: PropTypes.bool,
        onSuccessClose: PropTypes.func,
        onCloseSmartcardError: PropTypes.func,
        modalSize: PropTypes.string,
        titleText: PropTypes.string,
        customPromotionalText: PropTypes.string,
    };

    static defaultProps = {
        onRegister: _.noop,
        onCancel: _.noop,
        onSuccessClose: _.noop,
        hideSmartcardCheckbox: false,
        disableSuccessDropdown: false,
        onSmartcardSuccess: _.noop,
        withISRN: false,
        modalSize: false,
        titleText: 'account.heading.smartcard.apply',
    };

    state = {
        showModal: true,
        smartcard: new SmartcardRegistration({
            signup: SignupTypes.WITH_SMARTCARD,
            selfRegistered: this.props.withISRN,
            autoDrOptedIn: true
        }),
        submitted: false,
    };

    _handleSmartcardUpdate = (field, value) => {
        this.setState({ smartcard: this.state.smartcard.set(field, value) });
    };

    _handleSmartcardAddressSelected = (address) => {
        const updatedSmartcard = this.state.smartcard.merge({
            addressLine1: address.get('line1'),
            addressLine2: address.get('line2'),
            addressLine3: address.get('line3'),
            townCity: address.get('town'),
            postcode: address.get('postCode')
        });
        this.setState({
            smartcard: updatedSmartcard,
            submitted: false
        });
    };

    _onCancel = () => {
        this.setState({ showModal: false });
        this.props.onCancel();
        ModalActions.close(GlobalModals.REGISTER_SMARTCARD);
    };

    _onSave = async () => {
        const { smartcard } = this.state;
        const { user, onSmartcardSuccess, withISRN, onSuccessClose, onCloseSmartcardError } = this.props;

        this.setState({
            submitted: true
        });

        try {
            const newSmartcard = withISRN ? await CustomerActions.linkSmartcard(user, smartcard, { isUpdate: true }) : await CustomerActions.registerSmartcard(user, smartcard);

            if (onSmartcardSuccess) {
                onSmartcardSuccess();
            }

            this.setState({
                showModal: false
            });

            if (newSmartcard) {
                ModalActions.open(RegisterSuccessModal,
                    {
                        smartcard: !withISRN && newSmartcard,
                        disableSuccessDropdown: this.props.disableSuccessDropdown,
                        onSuccessClose
                    }
                );
            }

            this.props.onRegister();

        } catch (error) {
            if (error instanceof SelfSmartcardRegistrationError) {
                ModalActions.open(GlobalModals.INFO, {
                    type: 'warning',
                    title: 'account.register.selfSmartcardError',
                    message: serviceUnavailable(error.extra.error.body.status) ? 'error.general.message' : 'account.register.selfSmartcardErrorMessage',
                    onClose: () => onCloseSmartcardError(user, SmartcardSelfRegistrationStatuses.NEW_SMARTCARD),
                });
            } else {
                this.setState({ submitted: false });
                throw error;
            }
        }
    };

    render () {
        if (!this.state.showModal) {
            return null;
        }

        const { user, hideSmartcardCheckbox, modalSize, titleText, customPromotionalText } = this.props;
        const { smartcard, submitted } = this.state;

        return (
            <BaseModal
                onClose={ this._onCancel }
                onContinue={ this._onSave }
                closeText={ 'button.text.cancel' }
                continueText = 'account.register'
                disableContinue={ !(smartcard.withSmartcard() && smartcard.isComplete()) || submitted }
                className={ `${modalSize || 'modal--sm'} modal--standard` }
                titleText={ titleText }
            >
                <RegisterSmartcard
                    ref="smartcard"
                    user={ user }
                    smartcard={ smartcard }
                    onChange={ this._handleSmartcardUpdate }
                    onSelectAddress={ this._handleSmartcardAddressSelected }
                    hideSmartcardCheckbox={ hideSmartcardCheckbox }
                    customPromotionalText={ customPromotionalText }
                />
            </BaseModal>
        );
    }

}


export default SmartcardModal;



// WEBPACK FOOTER //
// ./src/components/account/SmartcardModal.js